import useInfiniteFetch from '@hooks/useInfiniteFetch';

const usePracticesByFilters = (
  { userName },
  { filtersApplied },
  options = { fallbackData: undefined }
) => {
  const key = `v1/search_v3/educators/${userName}/dpp_practice/all/?limit=16&filters_applied=${JSON.stringify(
    filtersApplied
  )}`;

  const { data: practicesByFilters, ...rest } = useInfiniteFetch(
    key,
    {
      applyOffsetsAutomatically: false,
      hasQueryParams: true
    },
    {
      fallbackData: options?.fallbackData,
      revalidateOnMount: true,
      revalidateFirstPage: false
    }
  );

  return {
    key,
    practicesByFilters,
    ...rest
  };
};

export default usePracticesByFilters;
